import script from "./CoreUiChatHistoryMessageReactionList.vue?vue&type=script&lang=ts&setup=true"
export * from "./CoreUiChatHistoryMessageReactionList.vue?vue&type=script&lang=ts&setup=true"

import "./CoreUiChatHistoryMessageReactionList.vue?vue&type=style&index=0&id=8e720650&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8e720650"]])

export default __exports__